module.exports = __webpack_public_path__ + "static/bgSmartphone-min-ab290121b7b91d4af3bd002b51b87517.jpg";